import api from "../api";

export const updateContactGat = async (data: any): Promise<any> => {
  const result = await api.put(`/contact`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const createContactGat = async (data: any): Promise<any> => {
  const result = await api.post(`/contact`, data);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const deleteContactGat = async (id: string): Promise<boolean> => {
  const result = await api.delete(`/contact?Id=${id}`);
  if (result.status === 200) {
    return true;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export interface ContactListFilters {
  name?: string;
  email?: string;
  phone?: string;
}

export const getContactsByUserIdGat = async (
  userId: string,
  page: number,
  rowsPerPage: number,
  filters?: ContactListFilters
): Promise<any> => {
  const params = new URLSearchParams();
  params.append("userId", userId);
  params.append("pageNumber", String(page));
  params.append("pageSize", String(rowsPerPage));
  if (filters?.name?.trim()) params.append("name", filters.name.trim());
  if (filters?.email?.trim()) params.append("email", filters.email.trim());
  if (filters?.phone?.trim()) params.append("phone", filters.phone.trim());

  const result = await api.get(`/contact/get-all-user?${params.toString()}`);

  if (result) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getContactGat = async (id: string): Promise<any> => {
  const result = await api.get(`/contact/?Id=${id}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getContactByEmailGat = async (email: string, userId: string): Promise<any> => {
  const q = encodeURIComponent(email);
  const result = await api.get(
    `/contact/get-contact-email?email=${q}&UserId=${userId}`
  );
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível cadastrar Assinantes");
  }
};

export const getDocumentSignGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/documents/download?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};

export const getSignersEditGat = async (documentId: string): Promise<any> => {
  const result = await api.get(`/users/signers/edit?documentId=${documentId}`);
  if (result.status === 200) {
    return result;
  } else {
    throw new Error("Não foi possível pegar o Documento");
  }
};
